import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Schedule from "views/admin/schedule";
import Profile from "views/admin/profile";

// Icon Imports
import {
  MdGridView,
  MdPerson,
  MdOutlineCalendarToday,
  MdSupervisedUserCircle,
  MdMeetingRoom,
  MdMenuBook,
  MdOutlinePeopleAlt,
  MdSettings,
  MdSmartphone,
} from "react-icons/md";

// Icon Imports
import { FaSchoolFlag } from "react-icons/fa6";
import { GiForkKnifeSpoon } from "react-icons/gi";

import Users from "views/admin/users";
import UserDetail from "views/admin/users/user_detail";
import RoomDetail from "views/admin/rooms/room_detail";
import ExamDetail from "views/admin/exam/exam_detail";
import Rooms from "views/admin/rooms";
import Buildings from "views/admin/buildings";
import BuildingDetail from "views/admin/buildings/building_detail";
import LessonDetail from "views/admin/lessons/lesson_detail";
import Lessons from "views/admin/lessons";
import Courses from "views/admin/courses";
import CourseDetail from "views/admin/courses/course_detail";
import Settings from "views/admin/settings";
import Shifts from "views/admin/settings/shifts";
import ShiftDetail from "views/admin/settings/shifts/shift_detail";
import Times from "views/admin/settings/times";
import ScheduleDetail from "views/admin/schedule/schedule_detail";
import Journal from "views/admin/journal";
import StudentsList from "views/admin/courses/components/students_list";
import TeacherSchedule from "views/admin/teacher_schedule";
import TeacherLesson from "views/admin/teacher_lesson";
import Exam from "views/admin/exam";
import ScheduleAdd from "views/admin/schedule/create_schedule/schedule_add";
import ScheduleView from "views/admin/schedule/schedule_view/schedule_view";
import OtherApps from "views/admin/otherapps";
import Food from "views/admin/food";
import FoodDetails from "views/admin/food/details";
import FoodCalendar from "views/admin/food/calendar";
import AngiBagtslah from "views/admin/food/angi_bagtslah";
import AngiBagtslahDetails from "views/admin/food/angi_bagtslah/details";
import KindergartenSchedule from "views/admin/kindergarten/schedule";
import KindergartenScheduleDetail from "views/admin/kindergarten/schedule/kindergarten_schedule_detail";
import KindergartenScheduleAdd from "views/admin/kindergarten/schedule/kindergarten_schedule_add";
import FoodSale from "views/admin/food_sale";

const routes = [
  {
    name: "Үндсэн хэсэг",
    layout: "/admin",
    path: "default",
    icon: <MdGridView className="h-6 w-6" />,
    component: <MainDashboard />,
    permissions: ["*"],
  },
  {
    name: "Хэрэглэгчид",
    layout: "/admin",
    path: "users",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <Users />,
    permissions: ["m"],
  },
  {
    name: "Хичээлийн хуваарь",
    layout: "/admin",
    path: "schedule",
    icon: <MdOutlineCalendarToday className="h-6 w-6" />,
    component: <Schedule />,
    permissions: ["sm"],
  },
  {
    name: "Өдрийн дэглэм",
    layout: "/admin",
    path: "kindergarten_daily",
    icon: <MdOutlineCalendarToday className="h-6 w-6" />,
    component: <KindergartenSchedule />,
    permissions: ["km"],
  },

  {
    name: "Өдрийн дэглэм нэмэх",
    layout: "/admin",
    path: "kindergarten_daily_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <KindergartenScheduleDetail />,
    permissions: ["-"],
  },
  {
    name: "Өдрийн дэглэм засах",
    layout: "/admin",
    path: "kindergarten_daily_detail/:id",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <KindergartenScheduleDetail />,
    permissions: ["-"],
  },
  {
    name: "Өдрийн дэглэм зохиох",
    layout: "/admin",
    path: "kindergarten_daily_add/:id",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <KindergartenScheduleAdd />,
    permissions: ["-"],
  },

  {
    name: "Журнал",
    layout: "/admin",
    path: "journal",
    icon: <MdOutlineCalendarToday className="h-6 w-6" />,
    component: <Journal />,
    permissions: ["t"],
  },
  {
    name: "Шалгалт",
    layout: "/admin",
    path: "exam",
    icon: <MdOutlineCalendarToday className="h-6 w-6" />,
    component: <Exam />,
    permissions: ["t"],
  },
  {
    name: "Шалгалт бүртгэл",
    layout: "/admin",
    path: "exam_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <ExamDetail />,
    permissions: ["-"],
  },
  {
    name: "Багшийн хуваарь",
    layout: "/admin",
    path: "teacher_sch",
    icon: <MdOutlineCalendarToday className="h-6 w-6" />,
    component: <TeacherSchedule />,
    permissions: ["t"],
  },

  {
    name: "Хичээлийн байр",
    layout: "/admin",
    path: "buildings",
    icon: <FaSchoolFlag className="h-6 w-6" />,
    component: <Buildings />,
    permissions: ["m"],
  },
  {
    name: "Анги танхим",
    layout: "/admin",
    path: "rooms",
    icon: <MdMeetingRoom className="h-6 w-6" />,
    component: <Rooms />,
    permissions: ["m"],
  },
  {
    name: "Хичээлүүд",
    layout: "/admin",
    path: "lessons",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <Lessons />,
    permissions: ["m"],
  },
  {
    name: "Миний хичээлүүд",
    layout: "/admin",
    path: "teacher_ls",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <TeacherLesson />,
    permissions: ["t"],
  },
  {
    name: "Ангиуд",
    layout: "/admin",
    path: "course",
    icon: <MdOutlinePeopleAlt className="h-6 w-6" />,
    component: <Courses />,
    permissions: ["m"],
  },

  {
    name: "Сургалтын апп-ууд",
    layout: "/admin",
    path: "otherapp",
    icon: <MdSmartphone className="h-6 w-6" />,
    component: <OtherApps />,
    permissions: ["-"],
  },

  // NON SIDE MENU ROUTES
  {
    name: "Хэрэглэгч",
    layout: "/admin",
    path: "user_add",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <UserDetail />,
    permissions: ["-"],
  },
  {
    name: "Хэрэглэгч",
    layout: "/admin",
    path: "user_edit/:id",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <UserDetail />,
    permissions: ["-"],
  },
  {
    name: "Барилга",
    layout: "/admin",
    path: "building_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <BuildingDetail />,
    permissions: ["-"],
  },
  {
    name: "Анги",
    layout: "/admin",
    path: "room_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <RoomDetail />,
    permissions: ["-"],
  },

  {
    name: "Хичээл",
    layout: "/admin",
    path: "lesson_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <LessonDetail />,
    permissions: ["-"],
  },

  {
    name: "Анги курс",
    layout: "/admin",
    path: "course_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <CourseDetail />,
    permissions: ["-"],
  },

  // SETTINGS ROUTES

  {
    name: "Ээлж",
    layout: "/admin",
    path: "shifts",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <Shifts />,
    permissions: ["-"],
  },
  {
    name: "Ээлж (засах, нэмэх)",
    layout: "/admin",
    path: "shift_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <ShiftDetail />,
    permissions: ["-"],
  },
  {
    name: "Завсарлага & Хичээлийн цаг",
    layout: "/admin",
    path: "times",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <Times />,
    permissions: ["-"],
  },

  {
    name: "Хичээлийн хуваарь (засах, нэмэх)",
    layout: "/admin",
    path: "schedule_detail",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <ScheduleDetail />,
    permissions: ["-"],
  },
  {
    name: "Хичээлийн хуваарь зохиох",
    layout: "/admin",
    path: "schedule_add",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <ScheduleAdd />,
    permissions: ["-"],
  },
  {
    name: "Сурагчид",
    layout: "/admin",
    path: "students_list",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <StudentsList />,
    permissions: ["-"],
  },
  {
    name: "Хичээлийн хуваарь харах",
    layout: "/admin",
    path: "schedule_view",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component: <ScheduleView />,
    permissions: ["-"],
  },

  // Food routes
  {
    name: "Хоол бүртгэл",
    layout: "/admin",
    path: "food",
    icon: <GiForkKnifeSpoon className="h-6 w-6" />,
    component: <Food />,
    permissions: ["f"],
  },
  {
    name: "Хоолны дэлгэрэнгүй",
    layout: "/admin",
    path: "food/details/:id",
    icon: <GiForkKnifeSpoon className="h-6 w-6" />,
    component: <FoodDetails />,
    permissions: ["-"],
  },
  {
    name: "Хоолны цэс",
    layout: "/admin",
    path: "calendar",
    icon: <GiForkKnifeSpoon className="h-6 w-6" />,
    component: <FoodCalendar />,
    permissions: ["f"],
  },
  {
    name: "Хоол борлуулах",
    layout: "/admin",
    path: "sale",
    icon: <GiForkKnifeSpoon className="h-6 w-6" />,
    component: <FoodSale />,
    permissions: ["*"],
  },
  {
    name: "Тохиргоо",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Settings />,
    permissions: ["m"],
  },
  {
    name: "Профайл",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    permissions: ["*"],
  },
  {
    name: "Анги багцлах",
    layout: "/admin",
    path: "angi-bagstlagh",
    icon: <MdMeetingRoom className="h-6 w-6" />,
    component: <AngiBagtslah />,
    permissions: ["*"],
  },
  {
    name: "Анги багцлах",
    layout: "/admin",
    path: "angi-bagstlagh/:id",
    icon: <MdMeetingRoom className="h-6 w-6" />,
    component: <AngiBagtslahDetails />,
    permissions: ["-"],
  },
];
export default routes;
